// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","BarContainer":"BarContainer-24zjdwjy8zqv78wym19ymzec5fqy4nfgrnw6ymy7wvhx25gfsh33mf563ezbtyheq654a7nufbxph2yp87u1spsyzhw3n1vwtkfsafb","loading":"loading-vsudpfwveqmqqss3pecxt6qnqugza61eyhte31y1zbrkkmbjyj71sew9hu1xu2ddmagjdpf9jg46kzzns3zay61tv4n9zm4dur79as","pulse":"pulse-3whvcdfe3c9xg9fcybvusfhv2gdw1w3d4rngem5qak7q7e8z6zxsmfnvbw3e97tavn6qt6bqpb8mcz5537st24cqgc6jhmfjqma3tek"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Placeholder/components/ContentBar/ContentBar.module.scss
// module id = 1310
// module chunks = 0